export default {
  forDitHjem: 'Derhjemme',
  saveUpTo12: 'Spar op til 18%',
  avgYearly: 'gns. på dit årlige elforbrug',
  homeDisclaimer: '*Beregnet ud fra sammenligning med andre udbydere.',
  seeCalculation: 'Se hele beregningen',
  withEv: 'Elbil',
  saveUpTo30: 'Spar op til 30%*',
  onCharging: 'på din ladning',
  evDisclaimer: '*Beregnet besparelse i forhold til gns. planlagt månedsafregning mellem 00:00-04:00. Analyse baseret på elpriser fra juli 2025.',
  combined50: 'Minimum 50% billigere gebyrer',
  combinedDisclaimer: '*Sammenlignet med gennemsnitlige gebyrer (abonnement + tillæg) hos andre udbydere. Baseret på test af 14+ udbydere.',
  seeStromligning: 'Se sammenligning på stromligning.dk',
  calculateSavings: 'Beregn besparelse',
  choosePlan: 'Vælg den aftale der passer til dig',
  allPlansNoBinding: 'Alle El-Aftaler uden binding. Skift når du vil.',
  elAftale: 'El-aftale',
  elAftalePrice: '0,72 kr./kWh',
  spot11NoMarkup: 'Spotpris 1:1 uden tillæg',
  spotNoMarkup: 'Spotpris uden tillæg',
  noMarkupToSpot: 'Ingen tillæg til spotprisen',
  freeApp: 'Saving Mode app inkluderet',
  noBinding: 'Ingen binding',
  seeElPlans: 'Se el-aftaler',
  chargerPlusEl: 'Ladeboks + El',
  allIncluded: 'Alt inkluderet',
  chargerFrom: 'Ladeboks fra 3.999 kr.',
  smartChargeDay1: 'Saving Mode fra dag ét',
  freeService: 'Serviceaftale inkluderet',
  elIncluded: 'El-aftale inkluderet',
  seeChargerPackages: 'Se ladepakker',
  solarAgreement: 'Solcelleaftale',
  noSupplierFee: 'Ingen leverandørgebyr',
  zeroKr: '0 kr.',
  supplierFee: 'leverandørgebyr',
  alsoAfter2026: 'Også efter 2026',
  freeProduction: 'Produktionsaftale uden leverandørgebyr',
  noHiddenFees: 'Ingen skjulte gebyrer',
  autoSettlement: 'Automatisk afregning',
  flexibleCancel: 'Fleksibel opsigelse',
  seeSolar: 'Se solcelleaftale',
  socialProofTitle: 'Danskere sparer tusindvis med enkel',
  socialProofSubtitle: 'Se hvorfor tusindvis af danskere har valgt enkel energi',
  trustpilotPlaceholder: 'Trustpilot widget kommer her',
  trustpilotInstructions: 'Se instruktioner i JSX-kommentarer ovenfor for at tilføje Trustpilot widget',
  seeWhatDuCanSave: 'Se hvad du kan spare',
  subscriptionIncluded: 'Abonnement inkluderet i prisen',
  elAftalePrice: '0,72 kr./kWh',
  chargerPrice: 'Fra 3.999 kr.',
  chargerInclInstall: 'Ladeboks ekskl. installation',
  stromligningScoreTitle: 'Strømligning Score',
  stromligningRating: 'Enkel Energi er bedømt til {score} ud af 5 stjerner.',
  stromligningCertifiedTitle: 'Certificeret af Strømligning',
  stromligningCertifiedText: 'Enkel Energi har forpligtet sig til at følge Strømlignings kodeks for god skik, overholde dansk lovgivning og deltage i uvarslede kontroller.',
  enkelEnergiCompany: 'enkel energi',
  enkelEnergiPrice: '28 kr.',
  ewiiCompany: 'EWII',
  ewiiPrice: '54 kr.',
  okCompany: 'OK',
  okPrice: '105 kr.',
  norlysCompany: 'Norlys',
  norlysPrice: '150 kr.',
  andelCompany: 'Andel',
  andelPrice: '164 kr.',
};